@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="container">
  <div class="row">
    <div class="span9">
      <h1> Generate Update Report Message</h1>
    </div>
    <p class="lead">
      Generate an oadrUpdateReport payload for a specified Metadata Report as if a VTN had requested it be sent right now.
      The granularity specifies the length of intervals in the report, and the report back duration specifies length of the report history.
      For example, a granularity of PT15M and report back duration of PT60M would produce four 15-minute intervals containing data from the last hour.
      This does not send anything to external VTNs, just generates a sample payload.
    </p>
  </div>
  @if(isLoading) {
    <app-loader
      message="Loading...">
    </app-loader>
  } @else {
    <form name="requestForm" class="form-horizontal" [formGroup]="requestForm">
      <div class="form-group">
        <label for="reportSpecifierId"> Report Specifier Id (format: [id] : [report-specifier-id] : [label]): </label>
        <select id="reportSpecifierId" class="form-control" name="report_specifier_id" type="select" (change)="setChangeReport($event.target)" required >
          <option disabled selected value></option>
          @for(metadata_reports of metadataReports; track metadata_reports) {
            <option [value]="metadata_reports.id">{{metadata_reports.id}} : {{metadata_reports.report_specifier_id}}{{metadata_reports.label ? " : " : null}}{{metadata_reports.label}}</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="granularity"> Granularity: </label>
        <select id="granularity" class="form-control" name="g.granularity" type="select" (change)="setGranularity($event.target)" required >
          <option disabled value></option>
          @for(g of granularities; track g) {
            <option [value]="g.iso_8601_granularity" [selected]="granularitySelected.iso_8601_granularity === g.iso_8601_granularity">{{g.label}}</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="report_back_duration"> Report back duration: </label>
        <input id="report_back_duration" class="form-control" name="report_back_duration" [formControl]="requestForm.controls.report_back_duration" placeholder="PT60M" type="text" required>
        @if(requestForm.get('report_back_duration')?.invalid && (requestForm.get('report_back_duration')?.dirty || requestForm.get('report_back_duration')?.touched)) {
          <div class="text-danger">
            Report back duration is required.
          </div>
        }
      </div>

      <div class="form-group">
        <label for="backfill" class="form-check-label"> Backfill: </label>
        <br/>
        <input id="backfill" class="form-check-input" name="backfill" type="checkbox" [checked]="backfill" (change)="setBackfill($event.target)">
      </div>

      <button id="performAction" class="btn btn-primary" type="button" (click)="performAction()" [disabled]="!id || !report_back_duration">Perform action</button>
    </form>
    <h5> Request Results</h5>
    <blockquote class="blockquote" style="height: 500px">
      <textarea readonly class="form-control" style="height: 100%">{{result}}</textarea>
    </blockquote>
  }
</div>
